<template>
  <div>
    <v-app-bar
      elevation="0"
      :color="backgroundColor"
      :dark="darkMode"
      :app="false"
    >
      <v-toolbar-title v-if="business">
        <v-list-item-title class="font-weight-bold">
          <span
            v-if="
              business &&
              business.metadata &&
              business.metadata.remoteOrderBusinessName
            "
            >{{ business.name }}</span
          >
          <span v-else>Available Inventory</span>
        </v-list-item-title>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn color="pink" small @click="BackToOrder"
        >{{ orderTotal().total | currency }} | Back To Order Create</v-btn
      >

      <template
        v-slot:extension
        v-if="
          !orderCreated &&
          business &&
          business.metadata &&
          business.metadata.remoteOrderCategory
        "
      >
        <v-tabs v-if="Categories.length" v-model="tab" align-with-title>
          <v-tabs-slider color="red"></v-tabs-slider>

          <v-tab
            v-for="category in Categories"
            :value="category.id"
            @change="tabChange(category)"
            :key="category.id"
          >
            {{ category.name }}
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <div
      ref="scrollContainer"
      style="overflow-y: auto; height: calc(100vh - 64px)"
    >
      <SelectCollectionDialog
        v-model="showCollectionDialog"
        :collections="Collections"
        @select="onCollectionSelected"
      />

      <v-container fluid grid-list-lg>
        <v-layout column>
          <v-flex xs12 sm4 class="text-right">
            <v-layout row>
              <v-flex>
                <v-text-field
                  v-model="search"
                  outlined
                  prepend-inner-icon="search"
                  clearable
                  rounded
                  autofocus
                  dense
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex shrink>
                <v-dialog v-model="menu" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined v-bind="attrs" v-on="on">
                      <v-icon>mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <ModelTitle title="Filter" @close="menu = !menu" />
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-layout row align-center>
                            <v-flex class="pl-3"> Filter By Category </v-flex>
                            <v-flex shrink class="pr-3">
                              <v-switch
                                v-model="categorySearch"
                                inset
                              ></v-switch>
                            </v-flex>
                          </v-layout>

                          <v-select
                            v-if="categorySearch"
                            :items="Categories"
                            hide-details
                            item-text="name"
                            v-model="selectedCategory"
                            item-value="id"
                            label="Category"
                            dense
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-layout row align-center>
                            <v-flex class="pl-3"> Filter By Range </v-flex>
                            <v-flex shrink class="pr-3">
                              <v-switch v-model="rangeSearch" inset></v-switch>
                            </v-flex>
                          </v-layout>
                        </v-col>
                        <v-col class="px-4" v-if="rangeSearch">
                          <v-range-slider
                            v-model="range"
                            :max="max"
                            :min="min"
                            hide-details
                            class="align-center"
                          >
                            <template v-slot:prepend>
                              <v-text-field
                                dense
                                outlined
                                :value="range[0]"
                                class="mt-0 pt-0"
                                hide-details
                                single-line
                                type="number"
                                style="width: 60px"
                                @change="$set(range, 0, $event)"
                              ></v-text-field>
                            </template>
                            <template v-slot:append>
                              <v-text-field
                                dense
                                outlined
                                :value="range[1]"
                                class="mt-0 pt-0"
                                hide-details
                                single-line
                                type="number"
                                style="width: 60px"
                                @change="$set(range, 1, $event)"
                              ></v-text-field>
                            </template>
                          </v-range-slider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="submitFilter">
                        Submit
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex>
            <v-row>
              <v-col
                lg="3"
                sm="6"
                md="4"
                v-for="product in Products"
                :key="product.id"
              >
                <v-card
                  :loading="loading"
                  class="pointer mx-auto my-4"
                  outlined
                  max-width="374"
                >
                  <template #progress>
                    <v-progress-linear
                      color="deep-purple"
                      height="10"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <product-card
                    :product="product"
                    :shouldShowStock="shouldShowStock"
                  />

                  <quantity-action-buttons
                    :product="product"
                    :add="add"
                    :minus="minus"
                    :openDialog="openQuantityDialog"
                    :backgroundColor="backgroundColor"
                    :darkMode="darkMode"
                    :business="business"
                  />
                </v-card>
              </v-col>
            </v-row>

            <div
              class="text-center py-4"
              v-if="loading && this.options.page > 1"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <QuantitySelectorDialog
        v-model="showQtyDialog"
        :initialQty="currentProduct ? currentProduct.orderQuantity : 0"
        @save="updateQuantity"
        :maxQuantity="currentProduct ? currentProduct.balance : null"
        :allowExceedStock="
          business && business.metadata && business.metadata.orderOutStockItem
        "
      />
      <v-btn
        v-show="showBackToTop"
        color="primary"
        dark
        fab
        large
        fixed
        bottom
        right
        class="mb-6 mr-6"
        @click="scrollToTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
// import DateSelector from "@/components/DateSelector";
// import AutoComplete from "@/modules/Customer/components/AutoComplete";
import QuantitySelectorDialog from "@/modules/Order/RemoteOrderView/components/QuantitySelectorDialog.vue";
import ProductSearchBar from "@/modules/Order/InHouse/components/ProductSearchBar";
import orderService from "@/modules/Order/RemoteOrderView/service.js";
import productService from "@/modules/Product/service.js";
import categoryService from "@/modules/Product/Category/service.js";
import SelectCollectionDialog from "@/modules/Order/RemoteOrderView/components/SelectCollectionDialog.vue";
import collectionService from "@/modules/Product/Collection/service.js";

import { mapGetters } from "vuex";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/1708-success.json";
import _ from "lodash";
import GlobalFunction from "@/mixins/GlobalFunction";
import invoiceService from "@/modules/Invoice/service.js";
import productCard from "@/modules/Order/RemoteOrderView/components/productCard.vue";

export default {
  name: "create-in-house-order",
  props: {
    existingCart: {
      type: Array,
      default: () => [],
    },
    orderCustomerId: {
      default: null,
    },
  },
  data() {
    return {
      categoryCache: {},
      isLoadingMore: false,
      ProductHistory: [],
      draftKey: "runningOrder",
      showBackToTop: false,
      showQtyDialog: false,
      currentProduct: null,
      categoryWhere: {},
      showCollectionDialog: false,
      Collections: [],
      groupedProducts: [],
      listType: 0,
      rangeSearch: false,
      categorySearch: false,
      selectedCategory: null,
      min: 0,
      max: 2000,
      range: [0, 2000],
      menu: null,
      dialog: false,
      addCartDialog: false,
      Cart: [],
      tab: null,
      Categories: [],
      selectedProduct: null,
      imageDialog: false,
      sortBy: "name",
      search: "",
      Products: [],
      model: [],
      productId: null,
      editOrder: false,
      code: null,
      business: null,
      OpenOrder: [],
      sendOrder: false,
      customerId: null,
      selectedCustomer: null,
      Customer: null,
      loading: true,
      GroupProduct: [],
      name: null,
      phoneNumber: null,
      Order: {
        date: this.$moment().toISOString(),
        note: null,
        OrderDetails: [],
      },
      orderCreated: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 500, // or 10
        sortBy: ["Department.name", "Brand.name", "name"],
        sortDesc: [false, false, false],
      },
      limit: 500,
      offset: 0,
    };
  },
  components: {
    // DateSelector,
    // AutoComplete,
    productCard,
    QuantitySelectorDialog,
    SelectCollectionDialog,
    ProductSearchBar,
    Lottie,
    QuantityActionButtons: {
      name: "QuantityActionButtons",
      functional: true,
      props: [
        "product",
        "add",
        "minus",
        "openDialog",
        "backgroundColor",
        "darkMode",
        "business",
      ],
      render(h, ctx) {
        const p = ctx.props.product;
        return h("v-card-actions", { class: "justify-center py-3" }, [
          // Minus Button
          p.orderQuantity
            ? h(
                "v-btn",
                {
                  props: {
                    color: "red darken-1",
                    fab: true,
                    xLarge: true,
                    disabled: p.orderQuantity == 0,
                  },
                  class: "my-button-no-zoom",
                  on: { click: () => ctx.props.minus(p) },
                },
                [h("v-icon", { props: { size: 30 } }, "mdi-minus")]
              )
            : h(
                "v-btn",
                {
                  props: { disabled: true, fab: true, xLarge: true },
                },
                [h("v-icon", { props: { size: 30 } }, "mdi-minus")]
              ),

          // Quantity Button
          h(
            "v-btn",
            {
              props: {
                outlined: true,
                xLarge: true,
              },
              class: "mx-2 my-button-no-zoom",
              on: { click: () => ctx.props.openDialog(p) },
            },
            [h("h2", { class: "font-weight-bold" }, p.orderQuantity)]
          ),

          // Plus Button
          h(
            "v-btn",
            {
              props: {
                color: ctx.props.backgroundColor,
                dark: ctx.props.darkMode,
                fab: true,
                xLarge: true,
                disabled:
                  !(
                    ctx.props.business &&
                    ctx.props.business.metadata &&
                    ctx.props.business.metadata.orderOutStockItem
                  ) && p.orderQuantity >= p.balance,
              },
              class: "my-button-no-zoom",
              on: { click: () => ctx.props.add(p) },
            },
            [h("v-icon", { props: { size: 30 } }, "mdi-plus")]
          ),
        ]);
      },
    },
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    name: {
      required,
    },
    phoneNumber: {
      required,
    },
  },
  computed: {
    ...mapGetters("global", ["currentBusiness", "currentUser"]),
    shouldShowStock() {
      return !(
        this.business &&
        this.business.metadata &&
        this.business.metadata.remoteOrderStockCount
      );
    },
    backgroundColor() {
      if (!this.business?.metadata?.remoteOrderBackgroundColor)
        return "#F0C316";

      return this.business.metadata.remoteOrderBackgroundColor;
    },
    darkMode() {
      if (!this.business?.metadata?.remoteOrderDarkMode) return false;

      return this.business.metadata.remoteOrderDarkMode;
    },
    numberOfPages() {
      let value = 0;
      if (this.count > 0) {
        value = this.count / this.options.itemsPerPage;
      }

      return value;
    },
  },
  watch: {
    orderCustomerId: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          // console.log("🔁 orderCustomerId changed:", newVal);
          const res = await invoiceService.getInvoiceByCustomer(newVal, {});
          this.Invoices = res?.data || [];
          // console.log("📄 Fetched invoices:", this.Invoices);

          // 🧩 Build purchase history map
          this.ProductHistory = {};

          this.Invoices.forEach((invoice) => {
            if (!invoice.InvoiceDetails) return;

            const currentDate = new Date(invoice.date);

            invoice.InvoiceDetails.forEach((detail) => {
              const productId = detail.ProductId;
              if (!productId) return;

              const qty = detail.qty || detail.quantity || 0;
              const entry = {
                date: currentDate,
                qty,
                invoiceId: invoice.id,
                invoiceNumber: invoice.localId || invoice.id,
                productName:
                  detail.name || (detail.Product ? detail.Product.name : null),
              };

              if (!this.ProductHistory[productId]) {
                this.ProductHistory[productId] = [];
              }

              this.ProductHistory[productId].push(entry);

              // Sort newest → oldest and keep last 3
              this.ProductHistory[productId].sort(
                (a, b) => new Date(b.date) - new Date(a.date)
              );
              this.ProductHistory[productId] = this.ProductHistory[
                productId
              ].slice(0, 3);
            });
          });

          // console.log("🧾 Product purchase history:", this.ProductHistory);
        }
      },
    },
    search: _.debounce(function () {
      this.options.page = 1;
      this.offset = 0;

      if (!this.search) {
        // search cleared
        this.getProduct();
      } else if (this.search.length > 1) {
        this.getProduct({ globalSearch: true });
      }
    }, 300),
  },

  async created() {
    if (!this.currentBusiness) return;

    this.business = this.currentBusiness;

    this.Cart = (this.existingCart || []).map((d) => {
      const qty = Number(d.qty || d.orderCount || 0);
      const price = Number(d.price || 0);

      return {
        id: d.ProductId, // ✅ product id goes into id
        ProductId: d.ProductId, // ✅ keep it explicit too
        name: d.name,
        price,
        orderQuantity: qty,
        orderCount: qty,
        totalPrice: qty * price,
        unitCountInBox: d.unitCountInBox || null,
        boxQty: d.boxQty || 1,

        // optional if you ever need it
        OrderDetailId: d.id,
      };
    });

    this.Cart.map((p) => {
      p.orderCount = p.qty;
    });

    if (this.business?.metadata?.collections) {
      await this.getCollection();

      // ✅ check for collectionId in URL
      const preselectedId = this.$route.query.collectionId;
      if (preselectedId) {
        const found = this.Collections.find((c) => c.id == preselectedId);
        if (found) {
          console.log("Auto-selected collection from URL:", found);
          this.onCollectionSelected(found);
        } else if (this.business?.metadata?.forceCollection) {
          this.showCollectionDialog = true;
          return false;
        }
      } else if (this.business?.metadata?.forceCollection) {
        this.showCollectionDialog = true;
        return false;
      }
    }

    await this.getCategory(this.categoryWhere);
    this.getPriceRange();
    await this.getProduct();

    if (this.business?.metadata?.remoteOrderCategory) {
      this.categorySearch = true;
    } else {
      this.categorySearch = false;
    }

    this.setProductOnCart();
  },
  mounted() {
    this.$refs.scrollContainer.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.$refs.scrollContainer.removeEventListener("scroll", this.handleScroll);
    this.categoryCache = {};
  },
  methods: {
    reloadCartFromParent() {
      this.Cart = JSON.parse(JSON.stringify(this.existingCart)) || [];

      this.setProductOnCart(); // this applies the quantities to Products[]
    },
    normalizeAndSortProducts(list) {
      const groups = {};

      list.forEach((p) => {
        const dept = p.Department ? p.Department.name : "Other";
        const brand = p.Brand ? p.Brand.name : "Unassigned";

        if (!groups[dept]) groups[dept] = {};
        if (!groups[dept][brand]) groups[dept][brand] = [];

        groups[dept][brand].push(p);
      });

      const sortedDepartments = Object.keys(groups).sort((a, b) =>
        a.localeCompare(b)
      );

      const final = [];

      sortedDepartments.forEach((dept) => {
        const brandGroups = groups[dept];

        const sortedBrands = Object.keys(brandGroups).sort((a, b) =>
          a.localeCompare(b)
        );

        sortedBrands.forEach((brand) => {
          const products = brandGroups[brand].sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          final.push(...products);
        });
      });

      return final;
    },
    // normalizeAndSortProducts(list) {
    //   const groups = {};

    //   list.forEach((p) => {
    //     let dept = p.Department ? p.Department.name : "Other";

    //     // ⭐ Force all products containing "Soap" into a single Soap group
    //     if (p.name.toLowerCase().includes("soap")) {
    //       dept = "Soap";
    //     }

    //     if (!groups[dept]) groups[dept] = [];
    //     groups[dept].push(p);
    //   });

    //   const sortedDepartments = Object.keys(groups).sort((a, b) =>
    //     a.localeCompare(b)
    //   );

    //   const final = [];

    //   sortedDepartments.forEach((dept) => {
    //     const products = groups[dept].sort((a, b) =>
    //       a.name.localeCompare(b.name)
    //     );
    //     final.push(...products);
    //   });

    //   return final;
    // },
    resetPagination() {
      this.options.page = 1;
      this.offset = 0;
      this.isLoadingMore = false;
      this.Products = [];
    },
    // async tabChange(val) {
    //   this.scrollToTop();

    //   this.search = "";

    //   this.resetPagination();

    //   this.selectedCategory = val.id;

    //   await this.getProduct();

    //   this.setProductOnCart();
    // },
    async tabChange(category) {
      this.scrollToTop();
      this.search = "";

      this.selectedCategory = category.id;

      this.resetPagination();

      await this.getProduct();
      this.setProductOnCart();
    },
    handleScroll() {
      const el = this.$refs.scrollContainer;

      this.showBackToTop = el.scrollTop > 100;

      const nearBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 250;

      if (this.Products.length >= this.count) {
        return;
      }

      if (nearBottom && !this.isLoadingMore) {
        this.isLoadingMore = true; // lock it immediately
        this.loadMoreProduct();
      }
    },
    scrollToTop() {
      this.$refs.scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    },
    async onCollectionSelected(collection) {
      this.categoryWhere = {
        collectionId: collection.id,
      };

      await this.getCategory(this.categoryWhere);

      if (this.Categories.length > 0) {
        this.getPriceRange();

        await this.getProduct();

        if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}cart`)) {
          this.Cart = JSON.parse(
            localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}cart`)
          );
        }

        if (this.business?.metadata?.remoteOrderCategory) {
          this.categorySearch = true;
        } else {
          this.categorySearch = false;
        }
        this.setProductOnCart();
        // this.loadCategoryAndProducts(collection.id);
      } else {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "No products found in this collection",
          });
        // console.log("Ime here");
        this.showCollectionDialog = true;
      }
    },
    openQuantityDialog(product) {
      this.currentProduct = product;
      this.showQtyDialog = true;
    },
    updateQuantity(qty) {
      console.log("updateQuantity ", qty);
      if (!this.currentProduct) return;
      this.$set(this.currentProduct, "orderQuantity", qty);

      // this.currentProduct.orderQuantity++;
      this.currentProduct.totalAmount = qty * this.currentProduct.price;
      this.submitQty(this.currentProduct);
      this.$forceUpdate();
    },
    submitFilter() {
      this.menu = !this.menu;
      this.getProduct();
    },
    BackToOrder() {
      this.$emit("cartItems", this.Cart);
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}cart`);
    },
    resetProduct() {
      this.Products = [];
      this.options.page = 0;
      this.limit = 500;
      this.offset = 0;
    },
    submitQty(product) {
      // if (product.orderQuantity && product.orderQuantity > product.balance) {
      if (
        !(
          this.business &&
          this.business.metadata &&
          this.business.metadata.orderOutStockItem
        ) &&
        product.orderQuantity > product.balance
      ) {
        console.log("Exceed order limit 2");
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Exceed order limit",
          });
        return false;
      } else {
        product.orderQuantity = parseFloat(product.orderQuantity);
        product.totalAmount =
          parseFloat(product.orderQuantity) * parseFloat(product.price);
        if (product.orderQuantity !== 0) {
          this.addToCart(product);
        }
        if (product.orderQuantity === 0 && product.cartProduct) {
          const index = this.Cart.findIndex((x) => x.id === product.id);
          this.Cart.splice(index, 1);
          product.cartProduct = false;
        }
      }
    },
    submitQtyFromCart() {
      if (
        this.selectedProduct.orderQuantity &&
        this.selectedProduct.orderQuantity > this.selectedProduct.balance
      ) {
        console.log("Exceed order limit 3");
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Exceed order limit",
          });
        return false;
      } else {
        this.selectedProduct.orderQuantity = parseFloat(
          this.selectedProduct.orderQuantity
        );
        this.selectedProduct.totalAmount =
          parseFloat(this.selectedProduct.orderQuantity) *
          parseFloat(this.selectedProduct.price);
        if (this.selectedProduct.orderQuantity !== 0) {
          this.addToCart(this.selectedProduct);
        }
        if (
          this.selectedProduct.orderQuantity === 0 &&
          this.selectedProduct.cartProduct
        ) {
          const index = this.Cart.findIndex(
            (x) => x.id === this.selectedProduct.id
          );
          this.Cart.splice(index, 1);
          this.selectedProduct.cartProduct = false;
        }

        this.addCartDialog = false;
        this.setProductOnCart();
      }
    },
    async addToCart(product) {
      // console.log('product', product)
      let found = false;
      await Promise.all(
        this.Cart.map((row) => {
          const rowPid = row.ProductId || row.id;
          if (rowPid === product.id) {
            found = true;
            if (product.cartProduct) {
              row.orderCount = parseFloat(product.orderQuantity);
              product.cartProduct = false;
            } else {
              row.orderCount = parseFloat(product.orderQuantity);
            }
            row.totalAmount =
              parseFloat(row.orderCount) * parseFloat(row.price);
          }
        })
      );
      if (!found) {
        product.orderCount = parseFloat(product.orderQuantity);
        this.Cart.push(product);
      }

      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}cart`,
        JSON.stringify(this.Cart)
      );
    },
    async addToCart1(product) {
      // console.log('product', product)
      let found = false;
      await Promise.all(
        this.Cart.map((row) => {
          if (row.id === product.id) {
            found = true;
            if (product.cartProduct) {
              row.orderCount = parseFloat(product.orderQuantity);
              product.cartProduct = false;
            } else {
              row.orderCount =
                parseFloat(row.orderCount) + parseFloat(product.orderQuantity);
            }
            row.totalAmount =
              parseFloat(row.orderCount) * parseFloat(row.price);
          }
        })
      );
      if (!found) {
        product.orderCount = parseFloat(product.orderQuantity);
        this.Cart.push(product);
      }

      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}cart`,
        JSON.stringify(this.Cart)
      );
    },
    openAdd(item, cartProduct) {
      // console.log('selectedProductselectedProduct', item)
      this.selectedProduct = item;
      if (cartProduct) {
        this.selectedProduct.cartProduct = cartProduct;
        this.selectedProduct.orderQuantity = parseFloat(
          this.selectedProduct.orderCount
        );
      } else {
        this.selectedProduct.orderQuantity = 0;
      }
      this.addCartDialog = !this.addCartDialog;
    },
    // setProductOnCart() {
    //   // console.log('setProductOnCart call', this.Cart.length)
    //   this.Cart.forEach((cartItem) => {
    //     // console.log('cartItem', cartItem)
    //     const product = this.Products.find(
    //       (product) => product.id === cartItem.id
    //     );
    //     if (product) {
    //       // console.log('product', cartItem.orderQuantity, cartItem.orderCount)
    //       this.$set(product, "orderQuantity", cartItem.orderQuantity || 0);
    //       this.$set(product, "orderCount", cartItem.orderCount || 0);
    //     }
    //   });
    // },
    reset() {
      this.$swal({
        title: "Are you sure?",
        text: `You like to reset your order list`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.value) {
          this.clearCart();
        }
      });
    },
    async clearCart() {
      this.Cart = [];
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}cart`);
      await this.getProduct();
      // this.setProductOnCart()
    },
    // setProductOnCart() {
    //   this.Cart.forEach((cartItem) => {
    //     // Support both shapes: product from this page OR OrderDetail row
    //     const productId = cartItem.id || cartItem.ProductId;

    //     const qty =
    //       cartItem.orderQuantity ??
    //       cartItem.orderCount ??
    //       cartItem.quantity ??
    //       cartItem.qty ??
    //       0;

    //     if (!productId || !qty) return;

    //     const product = this.Products.find((p) => p.id === productId);
    //     if (!product) return;

    //     this.$set(product, "orderQuantity", qty);
    //     this.$set(product, "orderCount", qty);
    //   });
    //   console.log("setting Cart after", this.Cart);
    // },
    setProductOnCart() {
      // console.log("set price got call", this.Cart);
      this.Cart.forEach((cartItem) => {
        const productId = cartItem.ProductId;
        const qty =
          cartItem.orderQuantity ??
          cartItem.orderCount ??
          cartItem.quantity ??
          cartItem.qty ??
          0;
        // console.log('cartItem', cartItem)
        if (!productId) return;

        const product = this.Products.find((p) => p.id === productId);
        // const product = this.Products.find((p) => {
        //   // console.log('pp',p, p.id, productId)
        //   if (p.id === productId) {
        //     return p;
        //   }
        // });

        if (!product) return;

        // Set quantity
        this.$set(product, "orderQuantity", Number(qty));
        this.$set(product, "orderCount", Number(qty));

        // console.log("cartItem", cartItem);
      });

      // console.log("setting Cart after", this.Cart);
    },
    orderTotal() {
      let value = {
        total: 0,
        count: 0,
      };

      this.Cart.map((product) => {
        // console.log('total cart', product, product.orderCount, product.totalPrice)
        const totalPrice = parseFloat(product.totalPrice || product.total || 0);
        if (product.orderCount) {
          value.count =
            parseFloat(value.count) + parseFloat(product.orderCount);
          value.total = parseFloat(value.total) + totalPrice;
        }
      });
      // console.log("value", value);
      return value;
    },
    openImageDialog(item) {
      this.selectedProduct = item;
      this.imageDialog = !this.imageDialog;
    },
    closeImageDialog() {
      this.imageDialog = !this.imageDialog;
      this.selectedProduct = null;
    },
    async newOrder() {
      console.log("i got pressed");
      this.Order = {
        date: this.$moment().toISOString(),
        note: null,
        OrderDetails: [],
      };
      this.orderCreated = false;
      this.$v.$reset();
    },
    getCategoryOrderTotal(obj) {
      let total = 0;
      obj.list.map((row) => {
        if (row.orderCount) {
          row.totalOrderAmount = row.price * row.orderCount;
          total = total + row.totalOrderAmount;
        }
      });
      return total;
    },
    productOrderCount() {
      for (const property in this.GroupProduct) {
        let total = 0;
        let totalOrder = 0;
        this.GroupProduct[property].list.forEach((row) => {
          if (row.orderCount && row.orderCount > 0) {
            total = total + row.orderCount;
            row.totalOrderAmount = row.price * row.orderCount;
            totalOrder = totalOrder + row.totalOrderAmount;
            // productPrice = total * row.price
          }
        });
        this.GroupProduct[property].order = total;
        this.GroupProduct[property].totalAmount = totalOrder;
      }
    },
    isOrderLimitExceeded(product) {
      const allowExceedStock =
        this.business &&
        this.business.metadata &&
        this.business.metadata.orderOutStockItem;

      return !allowExceedStock && product.orderQuantity >= product.balance;
    },
    add(product) {
      if (!product) return;

      // Always default orderQuantity to a number
      if (!product.orderQuantity) product.orderQuantity = 0;

      const allowExceedStock =
        this.business &&
        this.business.metadata &&
        this.business.metadata.orderOutStockItem;

      if (!allowExceedStock && product.orderQuantity >= product.balance) {
        // console.log("Exceed order limit 5");
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Exceed order limit",
          });
        return;
      }

      product.orderQuantity++;
      product.totalPrice = product.orderQuantity * product.price;
      this.submitQty(product);
      this.$forceUpdate();
    },
    minus(product) {
      // console.log('minus product', product)
      if (product.orderQuantity && product.orderQuantity !== 0) {
        product.orderQuantity--;
        product.totalPrice = product.orderQuantity * product.price;
      }
      // this.productOrderCount()
      this.submitQty(product);
      this.$forceUpdate();
    },
    addInOrderCart() {
      if (this.selectedProduct.orderQuantity) {
        if (
          this.selectedProduct.orderQuantity &&
          this.selectedProduct.orderQuantity >= this.selectedProduct.balance
        ) {
          console.log("Exceed order limit 1");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Exceed order limit",
            });
        } else {
          this.selectedProduct.orderQuantity++;
          this.selectedProduct.totalAmount =
            this.selectedProduct.orderQuantity * this.selectedProduct.price;
        }
      } else {
        this.selectedProduct.orderQuantity = 1;
        this.selectedProduct.totalAmount =
          this.selectedProduct.orderQuantity * this.selectedProduct.price;
      }
      this.$forceUpdate();
    },
    minusInOrderCart() {
      // console.log('minus product', product)
      if (
        this.selectedProduct.orderQuantity &&
        this.selectedProduct.orderQuantity !== 0
      ) {
        this.selectedProduct.orderQuantity--;
      }
      // this.productOrderCount()
      this.$forceUpdate();
    },
    add1(product) {
      if (product.orderCount) {
        if (product.orderCount && product.orderCount >= product.balance) {
          console.log("Exceed order limit 4");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Exceed order limit",
            });
        } else {
          product.orderCount++;
          product.totalAmount = product.orderCount * product.price;
        }
      } else {
        product.orderCount = 1;
        product.totalAmount = product.orderCount * product.price;
      }
      // this.productOrderCount()
      this.$forceUpdate();
    },
    minus1(product) {
      // console.log('minus product', product)
      if (product.orderCount && product.orderCount !== 0) {
        product.orderCount--;
      }
      // this.productOrderCount()
      this.$forceUpdate();
    },
    getCollection() {
      return collectionService
        .getAll({
          remoteOrder: true,
        })
        .then((result) => {
          // console.log("this.Category", result);
          this.Collections = result.data.sort((a, b) => {
            if (a.name < b.name) return -1; // `a` comes before `b`
            if (a.name > b.name) return 1; // `a` comes after `b`
            return 0; // Names are equal
          });

          // Set the first category as selected
          // this.selectedCategory =
          //   this.Categories.length > 0 ? this.Categories[0].id : null;
        })
        .catch((error) => {
          console.log("error getting collection", error);
        });
    },
    getCategory(where = {}) {
      const localWhere = {
        remoteOrder: true,
        ...where,
      };
      // console.log("localWhere", localWhere);
      return categoryService
        .getAll(localWhere)
        .then((result) => {
          this.Categories = result.data.sort((a, b) => {
            if (a.name < b.name) return -1; // `a` comes before `b`
            if (a.name > b.name) return 1; // `a` comes after `b`
            return 0; // Names are equal
          });

          // Set the first category as selected
          this.selectedCategory =
            this.Categories.length > 0 ? this.Categories[0].id : null;
          return this.selectedCategory;
        })
        .catch((error) => {
          console.log("error getting product", error);
        });
    },
    loadMoreProduct() {
      this.options.page++;
      this.getProduct();
    },
    getPriceRange() {
      return productService
        .getPriceRange()
        .then((result) => {
          if (result) {
            this.max = result.data.max_price;
            this.range = [0, this.max];
            // console.log('prince range result', result, this.max, this.range)
          }
        })
        .catch((error) => {
          console.log("error getting product", error);
        });
    },
    async getProduct(parms = {}) {
      const catId = this.selectedCategory;
      const page = this.options.page;
      const isSearching = !!this.search && this.search.length > 1;

      // 1. LOAD FROM CACHE (only when NOT searching)
      if (
        !isSearching &&
        catId &&
        this.categoryCache[catId] &&
        this.categoryCache[catId].pages[page]
      ) {
        // console.log("Loaded from CACHE for category:", catId, "page:", page);

        const cachedPages = this.categoryCache[catId].pages;

        let merged = Object.keys(cachedPages)
          .sort((a, b) => a - b)
          .flatMap((p) => cachedPages[p]);

        merged = this.normalizeAndSortProducts(merged);

        this.Products = merged;
        this.count = this.categoryCache[catId].totalCount;
        this.loading = false;
        this.isLoadingMore = false;

        await this.$nextTick(); // wait for Products rendering / re‑order
        this.setProductOnCart();
        return;
      }

      // console.log("calling server");

      // 2. FETCH FROM SERVER
      this.loading = true;
      const { itemsPerPage } = this.options;
      this.offset = itemsPerPage * (page - 1);

      let where = {
        key: this.code,
        hideZero: true,
        remoteOrder: true,
        hideParent: true,
        limit: this.limit,
        offset: this.offset,
        search: this.search,
        sortBy: ["Department.name", "name"],
        sortDesc: [false, false, false],
      };

      // if not searching, don't send "search" param at all
      if (!isSearching) {
        delete where.search;
      }

      if (this.selectedCategory) where.CategoryId = this.selectedCategory;
      if (this.rangeSearch) where.range = this.range;

      const result = await productService.getAll({ ...where, ...parms });
      // console.log("result server", result);

      // 3. SEARCH MODE → just show result, DO NOT touch cache
      if (isSearching) {
        let list = this.normalizeAndSortProducts(result.data || []);
        this.Products = list;
        this.count = result.count;
        this.loading = false;
        this.isLoadingMore = false;

        await this.$nextTick(); // wait for Products rendering / re‑order
        this.setProductOnCart();
        return;
      }

      // 4. NORMAL MODE → update cache and rebuild merged list
      if (!this.categoryCache[catId]) {
        this.categoryCache[catId] = { pages: {}, totalCount: result.count };
      }

      this.categoryCache[catId].pages[page] = result.data;
      this.categoryCache[catId].totalCount = result.count;

      const cachedPages = this.categoryCache[catId].pages;

      let merged = Object.keys(cachedPages)
        .sort((a, b) => a - b)
        .flatMap((p) => cachedPages[p]);

      merged = this.normalizeAndSortProducts(merged);

      this.Products = merged;
      this.count = result.count;
      this.loading = false;
      this.isLoadingMore = false;

      await this.$nextTick(); // wait for Products rendering / re‑order

      this.setProductOnCart();
    },
  },
};
</script>

<style scoped>
.listHeight {
  max-height: calc(100vh - 70px);
  width: 100%;
  overflow: auto;
}

.title-scroll {
  width: 370px; /* Set the width constraint */
  display: -webkit-box; /* Use a flexbox container */
  -webkit-line-clamp: 3; /* Limit to 3 lines */
  -webkit-box-orient: vertical; /* Set the orientation to vertical */
  overflow: hidden; /* Hide overflowing text */
  text-overflow: ellipsis; /* Add ellipsis for clipped text */
  word-wrap: break-word; /* Ensure words break naturally */
  overflow-wrap: break-word; /* Alternative for better word handling */
  word-break: keep-all; /* Prevent breaking words in half */
}

.touch-view-container {
  max-height: calc(100vh - 70px);
  width: 100%;
  overflow: auto;
}

.openOrderList {
  max-height: calc(100vh - 150px);
  width: 100%;
  overflow: auto;
}
.my-button-no-zoom {
  touch-action: manipulation;
}
.back-to-top-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}
</style>
